import { LoadingButton } from '@atlaskit/button';
import { flagReview } from '@atlassian/mpac-api-client';
import { log } from '@atlassian/mpac-utils';
import React, { useEffect, useState } from 'react';
import { useAsync } from 'react-async';
import { TEST_ID } from "../../../../../../constants";
export const FlagReview = ({
  mpacBaseUrl,
  flagEndpoint
}) => {
  const [isReviewFlagged, setIsReviewFlagged] = useState(false);
  const {
    isPending: isFlagInProgress,
    isFulfilled: isFlagSuccessful,
    isRejected: isFlagRejected,
    error: flagError,
    run: runFlagReview
  } = useAsync({
    deferFn: flagReview
  });
  useEffect(() => {
    if (isFlagRejected) log.error('ReviewsTab', 'failed to flag a review', {
      flagError
    });
  }, [isFlagRejected]);
  useEffect(() => {
    if (isFlagSuccessful) {
      setIsReviewFlagged(!isReviewFlagged);
    }
  }, [isFlagSuccessful]);
  const handleFlagReview = e => {
    e.preventDefault();
    const flagReviewUrl = "".concat(mpacBaseUrl).concat(flagEndpoint);
    runFlagReview(flagReviewUrl, !isReviewFlagged);
  };
  return /*#__PURE__*/React.createElement(LoadingButton, {
    appearance: "link",
    isLoading: isFlagInProgress,
    spacing: "none",
    onClick: handleFlagReview,
    testId: TEST_ID.REVIEWS_TAB_FLAG_UNFLAG_REVIEW
  }, isReviewFlagged ? 'Unflag' : 'Flag as inappropriate');
};